import React, { useState, useEffect } from 'react'
import { Steps, Space} from 'antd'
import { useKPSQspListQuery } from '../../store/DianShangYeWuApi';
import InvoiceNodeCheckApprove from './InvoiceNodeCheckApprove';
import InvoiceNodeCheckEdit from './InvoiceNodeCheckEdit';
function InvoiceNodeCheck(props) {
    const [items, setItems] = useState([])
    const {data, isSuccess} = useKPSQspListQuery({kpsq_sp_kpsq_id:props.kpsq_id},{skip:!props.kpsq_id})
    const [current, setCurrent] = useState(0);
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            // 然后 map，判断是否是最后一个元素
            const newArr =  data.Result.map(item => {
                const {
                    kpsq_sp_jd_name,
                    kpsq_sp_yh_name,
                    kpsq_sp_yh_id,
                    kpsq_sp_jd_xuhao,
                    kpsq_sp_content,
                    kpsq_sp_id,
                    kpsq_sp_dsbzd_id,
                    kpsq_sp_dsbzd_name,
                    kpsq_sp_state,
                    kpsq_sp_state_time,
                    kpsq_sp_uname,
                    kpsq_sp_ctime,
                    kpsq_sp_dsbzd_date,
                    kpsq_sp_dsbzd_date_end,
                    kpsq_sp_dsbzd_kh_id,
                    kpsq_sp_dsbzd_kh_name,
                } = item;
                return {
                    kpsq_sp_jd_name,
                    kpsq_sp_yh_name,
                    kpsq_sp_yh_id,
                    kpsq_sp_jd_xuhao,
                    kpsq_sp_content,
                    kpsq_sp_id,
                    kpsq_sp_dsbzd_id,
                    kpsq_sp_dsbzd_name,
                    kpsq_sp_state,
                    kpsq_sp_state_time,
                    kpsq_sp_uname,
                    kpsq_sp_ctime,
                    kpsq_sp_dsbzd_date,
                    kpsq_sp_dsbzd_date_end,
                    kpsq_sp_dsbzd_kh_id,
                    kpsq_sp_dsbzd_kh_name,
                }                
            })
            // 排序数据
            const sortedData = newArr.sort((a, b) => {
                return a.kpsq_sp_jd_xuhao - b.kpsq_sp_jd_xuhao;
            });
            // 生成 arr 并计算 current
            let firstApproveWithState2Index = -1; // 在 arr 中的索引（状态为 '2' 的审批点）
            let lastItemIndex = -1; // 在 arr 中的最后一个 item 的索引
            let arrIndex = 0; // arr 的当前索引
            
            const arr = sortedData.map((item) => {
                let result = null;
                if(item.kpsq_sp_jd_name === '审批' && item.kpsq_sp_state==='1'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:<span style={{fontSize:"12px"}}>{item.kpsq_sp_yh_name}</span>,
                        kpsq_sp_state:item.kpsq_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.kpsq_sp_jd_name === '审批' && item.kpsq_sp_state==='2'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:props.yh_id===item.kpsq_sp_yh_id ? <InvoiceNodeCheckApprove 
                                                                        sortedData={sortedData}
                                                                        yh_id={props.yh_id} 
                                                                        yh_name={props.yh_name} 
                                                                        kpsq_id={props.kpsq_id}
                                                                        kpsq_date={props.kpsq_date}
                                                                        kpsq_kh_id={props.kpsq_kh_id}
                                                                        kpsq_kh_name={props.kpsq_kh_name}
                                                                        kpsq_sp_id={item.kpsq_sp_id}
                                                                        kpsq_sp_jd_xuhao={item.kpsq_sp_jd_xuhao}
                                                                        kpsq_sp_jd_name={item.kpsq_sp_jd_name}
                                                                        kpsq_sp_yh_id={item.kpsq_sp_yh_id}
                                                                        kpsq_sp_yh_name={item.kpsq_sp_yh_name}
                                                                        kpsq_sp_uid={item.kpsq_sp_uid}
                                                                        kpsq_sp_uname={item.kpsq_sp_uname}
                                                                    /> : <span style={{fontSize:"12px"}}>{item.kpsq_sp_yh_name}</span>,
                        kpsq_sp_state:item.kpsq_sp_state,
                                                                    
                    }
                    // 找到第一个状态为 '2' 的审批点
                    if(firstApproveWithState2Index === -1){
                        firstApproveWithState2Index = arrIndex;
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.kpsq_sp_jd_name === '审批' && (item.kpsq_sp_state==='3' || item.kpsq_sp_state==='4' || item.kpsq_sp_state==='5')){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:props.yh_id===item.kpsq_sp_yh_id ? <InvoiceNodeCheckEdit 
                                                                        sortedData={sortedData}
                                                                        yh_id={props.yh_id} 
                                                                        yh_name={props.yh_name} 
                                                                        kpsq_id={props.kpsq_id}
                                                                        kpsq_date={props.kpsq_date}
                                                                        kpsq_kh_id={props.kpsq_kh_id}
                                                                        kpsq_kh_name={props.kpsq_kh_name}
                                                                        kpsq_sp_id={item.kpsq_sp_id}
                                                                        kpsq_sp_jd_xuhao={item.kpsq_sp_jd_xuhao}
                                                                        kpsq_sp_jd_name={item.kpsq_sp_jd_name}
                                                                        kpsq_sp_yh_id={item.kpsq_sp_yh_id}
                                                                        kpsq_sp_yh_name={item.kpsq_sp_yh_name}
                                                                        kpsq_sp_uid={item.kpsq_sp_uid}
                                                                        kpsq_sp_uname={item.kpsq_sp_uname}
                                                                        kpsq_sp_state={item.kpsq_sp_state}
                                                                        kpsq_sp_state_time={item.kpsq_sp_state_time}
                                                                        kpsq_sp_content={item.kpsq_sp_content}
                                                                    />: <Space orientation='vertical' size={0}>
                                                                            <span style={{color:item.kpsq_sp_state==='4' ? 'red' : 'green',fontWeight:"bold"}}>
                                                                                {item.kpsq_sp_state==='4' ? '驳回' : '同意'}
                                                                                {item.kpsq_sp_content? '：'+item.kpsq_sp_content :''}
                                                                            </span>
                                                                            <span>{item.kpsq_sp_yh_name} {item.kpsq_sp_state_time} </span>
                                                                        </Space>,
                                                                        kpsq_sp_state:item.kpsq_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.kpsq_sp_jd_name === '抄送' && item.kpsq_sp_state==='1'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.kpsq_sp_yh_name}</span>,
                        kpsq_sp_state:item.kpsq_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.kpsq_sp_jd_name === '抄送' && item.kpsq_sp_state==='2'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.kpsq_sp_yh_name}</span>,
                        kpsq_sp_state:item.kpsq_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.kpsq_sp_jd_name === '抄送' && item.kpsq_sp_state==='3'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.kpsq_sp_yh_name} {item.kpsq_sp_state_time}</span>,
                        kpsq_sp_state:item.kpsq_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                return result;
            })
            
            // 计算 current，规则优先级：'2' > '4' > 最后一个
            let calculatedCurrent = 0;
            let firstApproveWithState4Index = -1;

            // 查找 '2' 和 '4' 的索引
            arr.forEach((item, idx) => {
                if (item && item.kpsq_sp_state === '2' && firstApproveWithState2Index === -1) {
                    firstApproveWithState2Index = idx;
                }
                if (item && item.kpsq_sp_state === '4' && firstApproveWithState4Index === -1) {
                    firstApproveWithState4Index = idx;
                }
            });

            if (firstApproveWithState2Index !== -1) {
                calculatedCurrent = firstApproveWithState2Index;
            } else if (firstApproveWithState4Index !== -1) {
                calculatedCurrent = firstApproveWithState4Index;
            } else if (lastItemIndex !== -1) {
                calculatedCurrent = lastItemIndex;
            }

            // current 需要加上前面的"创建"和"提交"两个步骤
            setCurrent(calculatedCurrent + 2);
            setItems([{
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                content:<span style={{fontSize:"14px"}}>{props.kpsq_uname} {props.kpsq_ctime}</span>,
            },
            {
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                content:<span style={{fontSize:"14px"}}>{props.kpsq_uname} {props.kpsq_state_time}</span>,
            },...arr]);
        }else{
            setItems([]);
        }
        
        
    },[data, isSuccess,props.kpsq_id,props.kpsq_uname,props.kpsq_ctime,props.kpsq_state_time,props.kpsq_date,props.kpsq_kh_id,props.kpsq_kh_name,props.yh_id,props.yh_name])
    return (
        <Steps 
            items={items} 
            current={current} 
            size="small" 
            titlePlacement="vertical" 
        />
    )
}

export default InvoiceNodeCheck